// extracted by mini-css-extract-plugin
module.exports = {"SocialLink":"SocialLink_SocialLink__EKJsK","SocialLink_Inverse":"SocialLink_SocialLink_Inverse__rEn6G"};